import React, { useEffect, useState } from "react";
import { useTheme } from "../context/ThemeContext";
import { getLeaderboard } from "../services/api";

const MEDALS = {
  1: { label: "Gold", color: "#9a6b00", background: "#fff3c4" },
  2: { label: "Silver", color: "#5f6872", background: "#edf0f3" },
  3: { label: "Bronze", color: "#8b4f27", background: "#f6e1d1" },
};

export default function LeaderboardPage() {
  const { t } = useTheme();
  const [leaders, setLeaders] = useState([]);
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const load = async () => {
    setLoading(true);
    setError("");
    try {
      const data = await getLeaderboard();
      setLeaders(data.leaders || []);
      setCurrentUser(data.currentUser);
    } catch (err) {
      setError(err.message || "Unable to load leaderboard.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  return (
    <div style={{ maxWidth: 760, margin: "0 auto", padding: "100px 32px 80px" }}>
      <span style={{ fontSize: 11, color: t.text3, letterSpacing: "0.12em", fontWeight: 700 }}>POTD RANKINGS</span>
      <h1 style={{ fontSize: 38, color: t.text, margin: "8px 0 10px", fontFamily: "'Playfair Display',Georgia,serif" }}>Leaderboard</h1>
      <p style={{ color: t.text2, fontSize: 14, margin: "0 0 28px" }}>Top performers by total Problem of the Day points.</p>

      {loading ? <p style={{ color: t.text3 }}>Loading leaderboard...</p> : error ? (
        <div style={{ color: t.text2 }}><p>{error}</p><button onClick={load} style={{ background: t.primary, color: t.primaryFg, border: "none", borderRadius: 8, padding: "9px 16px", cursor: "pointer" }}>Try again</button></div>
      ) : (
        <section style={{ background: t.cardBg, border: `0.5px solid ${t.border}`, borderRadius: 14, overflow: "hidden" }}>
          {leaders.map((leader) => {
            const medal = MEDALS[leader.rank];
            const isCurrentUser = currentUser && String(currentUser._id) === String(leader._id);
            return (
              <div key={leader._id} style={{ display: "flex", alignItems: "center", gap: 14, padding: "15px 20px", borderBottom: `0.5px solid ${t.border}`, background: isCurrentUser ? t.bg2 : "transparent" }}>
                <strong style={{ width: 28, color: t.text3, fontSize: 13, textAlign: "center" }}>{leader.rank}</strong>
                {medal ? <span title={`${medal.label} badge`} style={{ width: 34, height: 34, borderRadius: "50%", display: "inline-flex", alignItems: "center", justifyContent: "center", background: medal.background, color: medal.color, fontSize: 16, fontWeight: 800 }}>{leader.rank}</span> : <span style={{ width: 34 }} />}
                <span style={{ flex: 1, color: t.text, fontSize: 14, fontWeight: 600 }}>{leader.name}{isCurrentUser && <span style={{ color: t.primary, fontSize: 12, marginLeft: 8 }}>(you)</span>}</span>
                <span style={{ color: t.text2, fontSize: 13, fontWeight: 700 }}>{leader.points} pts</span>
              </div>
            );
          })}
          {currentUser && !currentUser.inTopTen && (
            <div style={{ display: "flex", alignItems: "center", gap: 14, padding: "15px 20px", borderTop: `2px solid ${t.border}` }}>
              <strong style={{ width: 28, color: t.text3, fontSize: 13, textAlign: "center" }}>{currentUser.rank}</strong>
              <span style={{ width: 34 }} />
              <span style={{ flex: 1, color: t.text, fontSize: 14, fontWeight: 600 }}>{currentUser.name} (you)</span>
              <span style={{ color: t.text2, fontSize: 13, fontWeight: 700 }}>{currentUser.points} pts</span>
            </div>
          )}
          {!leaders.length && <p style={{ color: t.text3, fontSize: 13, padding: "20px" }}>No scores yet.</p>}
        </section>
      )}
    </div>
  );
}
